import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Default to light theme
  const isDarkTheme = false;

  useEffect(() => {
    // Apply light theme styles
    document.body.style.backgroundColor = '#f0f2f5';
    document.body.style.color = '#344767';
  }, []);

  const value = {
    isDarkTheme,
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
